import request from "@/utils/request";
// 查询长租购物车列表
export function getCartList(data) {
  return request({
    url: "/apis/emc/cart/getCartList",
    method: "post",
    data
  });
}
// 删除长租购物车
export function delCarCart(data) {
  return request({
    url: "/apis/emc/cart/delCarCart",
    method: "post",
    data
  });
}
// 修改长租购物车
export function updateCarCart(data) {
  return request({
    url: "/apis/emc/cart/updateCarCart",
    method: "post",
    data
  });
}
